export const restaurantTypes = {
  PayOnly: 'PayOnly',
  TipsOnly: 'TipsOnly',
  OrderAndPay: 'OrderAndPay',
};
